<jhi-bary-outlet-tabs [steps]="steps" [active]="active"></jhi-bary-outlet-tabs>
